import React, { memo, useCallback, useEffect, useId, useState } from 'react';

import { Box, Collapse, List, ListItemButton, ListSubheader, useTheme } from '@mui/material';
import { ArrowCheckIcon } from '@sharedCR/coreDesignSystem/icons';
import PropTypes from 'prop-types';

import { IconDirection } from 'constants/coreDesignSystem';

import { getStyles } from '../DynamicField.styles';

const CategoryWrapper = ({
  depth,
  hasFields,
  hasSearch,
  children,
  title,
  onCollapseClick,
  timeout = 120,
  ...rest
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const contentId = useId();
  const theme = useTheme();

  const classes = getStyles(theme, { depth });

  const onToggleExpand = useCallback(() => {
    setIsOpen(prev => !prev);
    onCollapseClick?.();
  }, [onCollapseClick]);

  useEffect(() => {
    setIsOpen(hasSearch);
  }, [hasSearch]);

  return (
    <Box component="li" {...rest}>
      <ListSubheader disableGutters component="div" sx={classes.listSubHeader}>
        <ListItemButton
          aria-controls={contentId}
          aria-expanded={isOpen}
          sx={classes.listSubHeaderButton}
          onClick={onToggleExpand}
        >
          <span>{title}</span>
          <Box sx={classes.expandIcon}>
            <ArrowCheckIcon direction={isOpen ? IconDirection.UP : IconDirection.DOWN} />
          </Box>
        </ListItemButton>
      </ListSubheader>
      <Collapse id={contentId} in={isOpen} timeout={timeout}>
        {isOpen && <List disablePadding>{children}</List>}
      </Collapse>
    </Box>
  );
};

CategoryWrapper.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  depth: PropTypes.number.isRequired,
  hasFields: PropTypes.bool.isRequired,
  hasSearch: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  timeout: PropTypes.number,
  onCollapseClick: PropTypes.func,
};

export default memo(CategoryWrapper);
